export class ApplicationDocumentTypes {
  static MATERIAL_LIST = 'material_list'
}
